<template>
  <div class="max-w-md mx-auto mt-4">
    <BaseCard class="">
      <div class="clearfix">
        <h1>404 - nie znaleziono</h1>
        <router-link tag="BaseButton" variant="primary" to="/"
          >Strona główna</router-link
        >
      </div>
    </BaseCard>
  </div>
</template>

<script>
export default {
  name: "Page404",
};
</script>
